const E = 50, s = {
  casino: 11,
  livespins: 11,
  poster: 11,
  "poster-jackpot": 8,
  providers: 15,
  video: 5
}, o = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, _ = /^([A-Z,.'-]+\s*)+$/i, t = /^[0-9]*$/, A = /{{2,3}\s*(\w+)\s*}{2,3}/gm;
export {
  o as EMAIL_REGEX,
  A as INTERPOLATION_REGEX,
  E as MAX_SLIDER_ITEMS,
  s as MAX_SLIDER_ITEMS_TO_LOAD,
  _ as NAME_REGEX,
  t as NUMBER_REGEX
};
